import { createSelector } from 'reselect'

import { selectGeneralReportsState } from './selectGeneralReportsState'

export const selectGeneralReportSearchStr = createSelector(
  [selectGeneralReportsState],
  ({ searchStr }) => searchStr
)
